export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["इलेक्ट्रॉनिक चेक सक्रियता"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्रेडिट खाता"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["संख्या"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["श्रृंखला"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रियता कोड"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जांचें"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रिय करें"])}
}